import React from 'react';
import TimePicker from '@lib/components/DateTimePicker/TimePicker';
import { ComponentProps, defaultProps } from '../types';

export default function TimePreview({ t }: ComponentProps) {
  return <TimePicker {...defaultProps} label={t('select-time')} />;
}
